import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { SvgIcon } from '@components/icon';
import { SmallText, StyledLinkButton } from '@components/shared/common';
import { LocationPinProps } from '@models/common/map';
import useYogaSaunaLocation from '@services/yoga-sauna/use-yoga-sauna-location';
import { parseUrlSlug } from '@utils/common';

import LocationAddress from './location-address';
import {
  PointerImg,
  PointerInfo,
  PointerLocationNameWrap,
  PointerWrap,
} from './location-marker.styled';

const LocationMarkerWithBookButton: React.FunctionComponent<LocationPinProps> = ({
  location,
}) => {
  const router = useRouter();
  const { yogaLocation } = useYogaSaunaLocation();

  const handleClick = () => {
    router.push(
      `/locations/[id]/[name]`,
      `/locations/${location.id}/${parseUrlSlug(location.name)}`,
    );
  };

  return (
    <PointerWrap>
      <PointerInfo>
        <PointerLocationNameWrap
          data-testid={`location-title-${location.name}`}
          onClick={handleClick}
        >
          <SmallText fWeight="600" transform="uppercase" align="center">
            Brightside {location.name}
          </SmallText>
          <SvgIcon
            width="7"
            alt="Arrow Right Icon"
            src="right-arrow-thick.svg"
          />
        </PointerLocationNameWrap>
        <div
          data-testid={`location-address-${location.city}`}
          css={{ textAlign: 'center' }}
        >
          <LocationAddress location={location} smallText centerText />
        </div>
        <Link
          href="/book-a-class/locations/[name]/available-sessions"
          as={`/book-a-class/locations/${parseUrlSlug(
            yogaLocation?.name || '',
          )}/available-sessions`}
        >
          <StyledLinkButton css={{ marginTop: 10 }}>Book Now</StyledLinkButton>
        </Link>
      </PointerInfo>
      <PointerImg>
        <SvgIcon width="58" src="location-marker.svg" alt="Location Marker" />
      </PointerImg>
    </PointerWrap>
  );
};

export default LocationMarkerWithBookButton;
